import {
    Box,
    Button,
    Card,
    Checkbox,
    Container,
    FormControl,
    FormLabel,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
  } from '@mui/material';
  import React, { useEffect, useState } from 'react';
  import { Helmet } from 'react-helmet-async';
  import { useNavigate } from 'react-router-dom';
  import imageCompression from 'browser-image-compression';
  import { FaArrowLeftLong } from 'react-icons/fa6';
  import { SlCloudUpload } from 'react-icons/sl';
  import Swal from 'sweetalert2';
  import { LoadingButton } from '@mui/lab';
  import { createRefill, createAroundUs, createQuestion, getBnbList, uploadFile, createTwilioNumbers, testTwilioNumbers } from '../../helper/backend_helper';
  import InfoTooltip from '../InfoTooltip';

  const AddPhoneNumber = () => {
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [number, setNumber] = useState('');

  
   
    const [loading, setLoading] = useState(false);

  

  
    const handleSave = async () => {
      try {
        setLoading(true);
        
        
        
      
  
  
        if (!name) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Name is required',
          });
          setLoading(false);
          return;
        }
        if (!number) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Number is required',
          });
          setLoading(false);
          return;
        }
       
  
        const Categorydata = {
        
          name,
          number
        };
        console.log(Categorydata);
        const Categoryheaders = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
  
        const response = await createTwilioNumbers(Categorydata, Categoryheaders);
  
    
  
        // Show success message
        Swal.fire({
          icon: 'success',
          title: 'Number created successfully',
        });
        setName('');
        setNumber('');
       
       
  
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${error?.response?.data?.errors[0]?.message}`,
        });
      }
    };
  


    const handleTest = async () => {
      try {
       
        if (!number) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Number is required',
          });
          setLoading(false);
          return;
        }
       
  
        const Categorydata = {
          number
        };
        console.log(Categorydata);
        const Categoryheaders = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
  
        const response = await testTwilioNumbers(Categorydata, Categoryheaders);
  
        console.log(response);
  
        // Show success message
        
       
       
  
    
      } catch (error) {
        console.error('Error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${error?.response?.data?.details}`,
        });
      }
    };



    return (
      <>
        <Helmet>
          <title> Add Phone Number </title>
        </Helmet>
        <Card sx={{ padding: 3 }}>
          <Stack
            onClick={() => navigate(-1)}
            gap={3}
            sx={{ cursor: 'pointer', mb: 3 }}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <FaArrowLeftLong size={24} />
            <Typography variant="h4">Add Phone Number</Typography>
          </Stack>
  
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { width: '50ch' },
            }}
            noValidate
            autoComplete="off"
          >
           
           
            <Stack sx={{ marginTop: 2 }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="Friendly label to identify this Twilio number internally (e.g. which BnB or purpose it serves)." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
           
            <Stack sx={{ marginTop: 2 }}>
              <FormLabel sx={{ mb: 1 }}>Number <InfoTooltip title="The Twilio phone number in full international format (e.g. +39…). Use Test to verify it works." /></FormLabel>
              <TextField
              type='number'
                label="Enter Number"
                id="outlined-size-small"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </Stack>
        
  
          </Box>
          <Stack direction="row" gap={2}>
          <LoadingButton
            sx={{
              width: 100,
              mt: 4,
              mb: 4,
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            onClick={handleSave}
            loading={loading}
          >
            Save
          </LoadingButton>
          <LoadingButton
            sx={{
              width: 100,
              mt: 4,
              mb: 4,
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            onClick={handleTest}
          >
            Test
          </LoadingButton>
          </Stack>
          
        </Card>
      </>
    );
  };
  
  export default AddPhoneNumber;
  